module.exports = __webpack_public_path__ + "img/hochzeit_zeremonie_ocular.e2f13946.jpg";